import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import Icon from "../../common/components/Icon/Icon";
import Button from "../../common/components/Forms/Button/Button";
import cx from "classnames";
import { QuoteGroupContext } from "../providers/RootContextProvider";
import styles from "./QuoteError.module.scss";

const QuoteError: React.FC = () => {
    const { selectors } = useContext(QuoteGroupContext);
    const hasAnyProductSelected = selectors.hasAnyProductEnabled();
    const history = useHistory();

    return (
        <React.Fragment>
            {hasAnyProductSelected ? (
                <div className={cx("layout-quote-error")}>
                    <Icon id="ErrorQuotes" />
                    <h3 className={cx("layout-quote-error-label text-align--center")}>
                        We can&apos;t seem to find any quotes for you.
                    </h3>
                    <Button
                        component="button"
                        onClick={() => history.push("/compare")}
                        variant="calltoaction"
                        size="s"
                        className={cx("layout-btn-m")}>
                        Try Again
                    </Button>
                </div>
            ) : (
                <div className={cx(styles["container"], "layout-flex-column")}>
                    <h3 className={cx("layout-hidden-mobile")}>
                        Select one or more products to view quotes.
                    </h3>
                    <h3
                        className={cx(
                            "layout-hidden-desktop",
                            "space-l",
                            "text-align--center"
                        )}>
                        <a href="/compare/products">Select one or more</a> products to
                        view quotes.
                    </h3>
                    <Icon
                        id="ErrorSelectProducts"
                        className={cx(styles["icon"], "layout-hidden-tablet")}
                    />
                </div>
            )}
        </React.Fragment>
    );
};

export default QuoteError;
